<script setup lang="ts">
import { computed } from "vue";

const route = useRoute();

const pageTitle = computed(() => (route.meta as any)?.title || "Informatie");
const pageSubtitle = computed(() => (route.meta as any)?.subtitle || "");
</script>

<template>
  <!-- Content-layout in de styling van de info-/landingspagina: gedeelde
       header/footer, titelblok uit de page-meta en de content in een card. -->
  <div
    class="min-h-dvh bg-[var(--main-background)] text-[var(--color-mode-text)]"
  >
    <InfoHeader />

    <!-- Titelblok -->
    <section class="px-5 pb-6 pt-14 md:px-8 md:pt-16">
      <div class="mx-auto max-w-4xl">
        <NuxtLink
          to="/info"
          class="mb-6 inline-flex items-center gap-1.5 text-sm text-neutral-500 transition hover:text-[var(--color-mode-text)]"
        >
          <UiIcon name="mdi:arrow-left" size="xs" />
          Terug naar overzicht
        </NuxtLink>
        <h1 class="text-3xl font-semibold tracking-tight md:text-5xl">
          {{ pageTitle }}
        </h1>
        <p v-if="pageSubtitle" class="mt-3 text-sm text-neutral-500 md:text-base">
          {{ pageSubtitle }}
        </p>
      </div>
    </section>

    <!-- Content -->
    <main class="px-5 pb-20 md:px-8">
      <div
        class="mx-auto max-w-4xl rounded-2xl border border-[var(--color-mode-border)] bg-[var(--primary)] p-6 md:p-10"
      >
        <slot />
      </div>
    </main>

    <InfoFooter />
  </div>
</template>
